import { IKonfigurationStParameter } from "../../Models/IKonfigurationStParameter";

export const getParameterList = (config: any) => {
  const params: IKonfigurationStParameter[] = [];

  let pos = 1;

  if (config?.schraubfall) {
    params.push({
      name: "schraubfall",
      wert: config?.schraubfall,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.selectedCollarNorm) {
    params.push({
      name: "selectedCollarNorm",
      wert: config?.selectedCollarNorm,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.selectedBolzenNorm) {
    params.push({
      name: "selectedBolzenNorm",
      wert: config?.selectedBolzenNorm,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.anzugsmoment?.nm > 0) {
    params.push({
      name: "anzugsmoment",
      wert:
        config?.anzugsmoment?.nm.toLocaleString() +
        " Nm / " +
        config?.anzugsmoment?.inlbs.toLocaleString() +
        " in.lbs",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.schluesselweite?.mm > 0) {
    params.push({
      name: "schluesselweite",
      wert:
        config?.schluesselweite?.mm.toLocaleString() +
        " mm / " +
        config?.schluesselweite?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.schluesselweite?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.fastenerProfile) {
    params.push({
      name: "fastenerProfile",
      wert: config?.fastenerProfile?.kurzwort,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.anzugsrichtung && config?.schraubfall == "rohrleitung") {
    params.push({
      name: "anzugsrichtung",
      wert: config?.anzugsrichtung,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.rueckstellung && config?.schraubfall == "rohrleitung") {
    params.push({
      name: "rueckstellung",
      wert: config?.rueckstellung,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearbox) {
    params.push({
      name: "selectGearbox",
      wert: config?.gearbox?.text,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gegenhalterSchluesselweite?.mm > 0) {
    params.push({
      name: "gegenhalterSchluesselweite",
      wert:
        config?.gegenhalterSchluesselweite?.mm.toLocaleString() +
        " mm / " +
        config?.gegenhalterSchluesselweite?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gegenhalterSchluesselweite?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gegenhalterAussenlaenge?.mm > 0) {
    params.push({
      name: "gegenhalterAussenlaenge",
      wert:
        config?.gegenhalterAussenlaenge?.mm.toLocaleString() +
        " mm / " +
        config?.gegenhalterAussenlaenge?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gegenhalterAussenlaenge?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gegenhalterVerschraubungslaenge?.mm > 0) {
    params.push({
      name: "gegenhalterVerschraubungslaenge",
      wert:
        config?.gegenhalterVerschraubungslaenge?.mm.toLocaleString() +
        " mm / " +
        config?.gegenhalterVerschraubungslaenge?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gegenhalterVerschraubungslaenge?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.retainingProfile && config?.schraubfall == "holdndrive") {
    params.push({
      name: "auswahlHalteprofil",
      wert: config?.retainingProfile?.kurzwort,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.maxRadius?.mm > 0) {
    params.push({
      name: "maxRadius",
      wert:
        config?.gearedOffsetHeadSpecifications?.maxRadius?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.maxRadius?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.maxRadius?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.maxKlingenstaerke?.mm > 0) {
    params.push({
      name: "maxKlingenstaerke",
      wert:
        config?.gearedOffsetHeadSpecifications?.maxKlingenstaerke?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.maxKlingenstaerke?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.maxKlingenstaerke?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.maxBreite?.mm > 0) {
    params.push({
      name: "maxBreite",
      wert:
        config?.gearedOffsetHeadSpecifications?.maxBreite?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.maxBreite?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.maxBreite?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.achsabstandMin?.mm > 0) {
    params.push({
      name: "minAchsabstand",
      wert:
        config?.gearedOffsetHeadSpecifications?.achsabstandMin?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.achsabstandMin?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.achsabstandMin?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.achsabstandMax?.mm > 0) {
    params.push({
      name: "maxAchsabstand",
      wert:
        config?.gearedOffsetHeadSpecifications?.achsabstandMax?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.achsabstandMax?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.achsabstandMax?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.auskraglaenge?.mm > 0) {
    params.push({
      name: "auskraglaenge",
      wert:
        config?.gearedOffsetHeadSpecifications?.auskraglaenge?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.auskraglaenge?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.auskraglaenge?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.kopfmass?.mm > 0) {
    params.push({
      name: "kopfmass",
      wert:
        config?.gearedOffsetHeadSpecifications?.kopfmass?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.kopfmass?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.kopfmass?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.durchmesserDMax?.mm > 0) {
    params.push({
      name: "durchmesserDMax",
      wert:
        config?.gearedOffsetHeadSpecifications?.durchmesserDMax?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.durchmesserDMax?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.durchmesserDMax?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.laengeLmax?.mm > 0) {
    params.push({
      name: "laengeLmax",
      wert:
        config?.gearedOffsetHeadSpecifications?.laengeLmax?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.laengeLmax?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.laengeLmax?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.gearedOffsetHeadSpecifications?.laengeLmin?.mm > 0) {
    params.push({
      name: "laengeLmin",
      wert:
        config?.gearedOffsetHeadSpecifications?.laengeLmin?.mm.toLocaleString() +
        " mm / " +
        config?.gearedOffsetHeadSpecifications?.laengeLmin?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.gearedOffsetHeadSpecifications?.laengeLmin?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (
    config?.gearedOffsetHeadSpecifications?.nussBit != undefined &&
    config?.gearedOffsetHeadSpecifications?.nussBit == true
  ) {
    params.push({
      name: "verschraubungNussBit",
      wert: "yes",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (
    config?.gearedOffsetHeadSpecifications?.abtriebsProfil != undefined &&
    config?.gearedOffsetHeadSpecifications?.kurzwort
  ) {
    params.push({
      name: "gearedOffsetHeadAbtriebsProfil",
      wert: config?.gearedOffsetHeadSpecifications?.kurzwort,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.outputSocketSpecifications?.laengeLmax?.mm > 0) {
    params.push({
      name: "outputSocketSpecificationsLaengeLmax",
      wert:
        config?.outputSocketSpecifications?.laengeLmax?.mm.toLocaleString() +
        " mm / " +
        config?.outputSocketSpecifications?.laengeLmax?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.outputSocketSpecifications?.laengeLmax?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.outputSocketSpecifications?.aussenlaengeALMin?.mm > 0) {
    params.push({
      name: "outputSocketSpecificationsAussenlaengeALMin",
      wert:
        config?.outputSocketSpecifications?.aussenlaengeALMin?.mm.toLocaleString() +
        " mm / " +
        config?.outputSocketSpecifications?.aussenlaengeALMin?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.outputSocketSpecifications?.aussenlaengeALMin?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.outputSocketSpecifications?.aussenlaengeALMax?.mm > 0) {
    params.push({
      name: "outputSocketSpecificationsAussenlaengeALMax",
      wert:
        config?.outputSocketSpecifications?.aussenlaengeALMax?.mm.toLocaleString() +
        " mm / " +
        config?.outputSocketSpecifications?.aussenlaengeALMax?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.outputSocketSpecifications?.aussenlaengeALMax?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (
    config?.outputSocketSpecifications?.abtriebsprofilDurchgehend !=
      undefined &&
    config?.outputSocketSpecifications?.abtriebsprofilDurchgehend == true
  ) {
    params.push({
      name: "outputSocketSpecificationsAbtriebsprofilDurchgehend",
      wert: "yes",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.outputSocketSpecifications?.profiltiefePMin?.mm > 0) {
    params.push({
      name: "outputSocketSpecificationsProfiltiefePMin",
      wert:
        config?.outputSocketSpecifications?.profiltiefePMin?.mm.toLocaleString() +
        " mm / " +
        config?.outputSocketSpecifications?.profiltiefePMin?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.outputSocketSpecifications?.profiltiefePMin?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.outputSocketSpecifications?.oeffnungsweiteCMin?.mm > 0) {
    params.push({
      name: "outputSocketSpecificationsOeffnungsweiteCMin",
      wert:
        config?.outputSocketSpecifications?.oeffnungsweiteCMin?.mm.toLocaleString() +
        " mm / " +
        config?.outputSocketSpecifications?.oeffnungsweiteCMin?.inchDez.toLocaleString() +
        " inch/dec. / " +
        config?.outputSocketSpecifications?.oeffnungsweiteCMin?.inch +
        " inch",
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  if (config?.outputSocketSpecifications?.abtriebsprofil) {
    params.push({
      name: "outputSocketSpecificationsAbtriebsprofil",
      wert: config?.outputSocketSpecifications?.abtriebsprofil?.kurzwort,
      guid: "",
      konfigGuid: "",
      pos: pos,
    });
    pos += 1;
  }

  return params;
};
